var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "mx-auto my-auto" },
    [
      _c("loading", {
        attrs: {
          dialog: true,
          loading: true,
          message: "Processing subscription..."
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }